export type HeaderValue = string | string[] | number | boolean | null;

export interface HttpHeaders {
  [key: string]: HeaderValue;
}

export type MutationParams<D = any, ID = number> =
  // POST
  | {
      id?: never;
      data: D;
      headers?: HttpHeaders;
    }
  // PUT
  | {
      id: ID;
      data: D;
      headers?: HttpHeaders;
    }
  // PATCH
  | {
      id: ID;
      data: Partial<D>;
      headers?: HttpHeaders;
    }
  // DELETE
  | {
      id: ID;
      data?: never;
      headers?: HttpHeaders;
    };

export const getMutationFn =
  <D, T>(
    postFn?: (data: D, headers?: HttpHeaders) => Promise<T>,
    patchFn?: (
      id: number,
      data: Partial<D>,
      headers?: HttpHeaders
    ) => Promise<T>,
    deleteFn?: (id: number, headers?: HttpHeaders) => Promise<void>
  ) =>
  ({ id, data, headers }: MutationParams<D>): Promise<T | void> =>
    (typeof id === 'undefined'
      ? postFn?.(data, headers)
      : !data
      ? deleteFn?.(id, headers)
      : patchFn?.(id, data, headers)) || Promise.resolve();
